document.addEventListener("DOMContentLoaded", () => {
  // ---------------------------------------------------------------------------
  // Dropdown elements
  // ---------------------------------------------------------------------------
  const dropdownButton = document.getElementById("dropdownDelayButton");
  const dropdownMenu = document.getElementById("dropdownDelayMenu");
  const dropdownIcon = dropdownButton?.querySelector("svg");

  if (!dropdownButton || !dropdownMenu || !dropdownIcon) return;

  // All dropdown items (cities)
  const items = dropdownMenu.querySelectorAll("[data-select-city-id]");

  // All cards that will be filtered
  const cards = document.querySelectorAll("[data-target-id-city]");

  // Animation duration (must match CSS transition time)
  const ANIMATION_DURATION = 300;

  // ---------------------------------------------------------------------------
  // INITIAL STATE
  // - Select first city visually
  // - Show only its cards
  // - Do NOT trigger dropdown open/close
  // ---------------------------------------------------------------------------
  if (items.length) {
    const firstItem = items[0];
    const firstCityId = firstItem.getAttribute("data-select-city-id");

    // Set dropdown button label
    dropdownButton.childNodes[0].textContent = firstItem.textContent.trim();

    // Mark first item as selected
    firstItem.classList.add("selected");

    // Initialize cards visibility
    cards.forEach((card) => {
      if (card.getAttribute("data-target-id-city") === firstCityId) {
        card.style.display = "";
        card.classList.add("is-visible");
        card.classList.remove("is-hidden");
      } else {
        card.style.display = "none";
        card.classList.add("is-hidden");
        card.classList.remove("is-visible");
      }
    });
  }

  // ---------------------------------------------------------------------------
  // HANDLE CITY SELECTION WITH SMOOTH TRANSITION
  // ---------------------------------------------------------------------------
  const selectCity = (item) => {
    const cityName = item.textContent.trim();
    const cityId = item.getAttribute("data-select-city-id");

    // Update dropdown button text
    dropdownButton.childNodes[0].textContent = cityName;

    // Update selected state in dropdown
    items.forEach((i) => i.classList.remove("selected"));
    item.classList.add("selected");

    // Fade out all cards
    cards.forEach((card) => {
      card.classList.add("is-hidden");
      card.classList.remove("is-visible");
    });

    // After fade-out, show only selected city cards
    setTimeout(() => {
      cards.forEach((card) => {
        if (card.getAttribute("data-target-id-city") === cityId) {
          card.style.display = "";

          // Force repaint to ensure transition runs
          requestAnimationFrame(() => {
            card.classList.remove("is-hidden");
            card.classList.add("is-visible");
          });
        } else {
          card.style.display = "none";
        }
      });
    }, ANIMATION_DURATION);

    // Let Flowbite handle dropdown closing
    dropdownButton.click();
  };

  // ---------------------------------------------------------------------------
  // CLICK EVENTS FOR DROPDOWN ITEMS
  // ---------------------------------------------------------------------------
  items.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation(); // Prevent scroll jump + Flowbite conflicts
      selectCity(item);
    });
  });

  // ---------------------------------------------------------------------------
  // SYNC ARROW ROTATION WITH FLOWBITE DROPDOWN STATE
  // ---------------------------------------------------------------------------
  dropdownButton.addEventListener("click", () => {
    setTimeout(() => {
      const isOpen = !dropdownMenu.classList.contains("hidden");
      dropdownIcon.classList.toggle("rotate-180", isOpen);
    }, 0);
  });
});
